import styled from 'styled-components';

const StyledMobileMenuWrap = styled.div`
  position: fixed;
  width: 100%;
  padding-top: 80px;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 3;
  opacity: 0;
  pointer-events: none;
  transition: opacity .5s ease-out;
  background-color: #fff;
  .mobile--slider-main p.active{
    color: ${props => props.theme.colors.green_secondary};
  }
  &.show{
    opacity: 1;
    pointer-events: all;
    overflow: auto;
    height: auto;
    padding-bottom: 80px;
  }
  .wrapper--flex{
    position: relative;
    padding: 64px 64px 140px;
    display: flex;
    flex-flow: row wrap;
  }
  @media screen and (max-width: 1023px){
    .wrapper--flex{
      padding: 24px 40px 0;
    }
    .single--link{
      padding: 72px 40px 0;
      font-size: 22.5px;
      line-height: 110%;
    }
  }
  @media screen and (max-width: 767px){
    .wrapper--flex{
      padding: 18px 24px;
    }
    .mobile--slider-wrap{
      position: absolute;
      height: calc(100% - 181px);
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .single--link{
      padding: 44px 24px 0;
      font-size: 22.5px;
      line-height: 110%;
      &:nth-child(1){
        padding-top: 20px;
      }
    }
    .mobile--slider-wrap .rounded--cta{
      position: fixed;
      width: calc(100% - 48px);
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
    }
    .mobile--slider-second{
      position: absolute;
      top: 20px;
      bottom: 0;
      background-color: #fff;
      left: 0;
      transform: translateX(100%);
      width: 100%;
      transition: transform .5s ease-out;
    }
    .mobile--slider-second.show{
      transform: translateX(0%)
    }
    .mobile--slider-second .back-cta{
      padding-left: 24px;
    }
  }
  .md--title{
    opacity: 0;
    transition: all .15s ease-out ;
  }
  &.show .md--title{
    opacity: 1;
  }
  
  .md--title:hover{
    color:rgba(0,0,0,0);
  }
  @media screen and (min-width: 1440px){
    .md--title:nth-child(1), .md--title:nth-child(3){
      padding-right: 80px;
    }
  }
  @media screen and (min-width: 1024px){
    .md--title:nth-child(1), .md--title:nth-child(3){
      padding-right: 64px;
    }
  }

`;

export {
  StyledMobileMenuWrap,
};

